module.exports = __webpack_public_path__ + "img/Icon ionic-md-arrow-dropleft.40d6f390.png";